import { selectMailboxesById } from './selectMailboxesById'

export const selectMailbox = (state, mailboxId) => {
  return selectMailboxesById(state)[mailboxId]
}
